import React, { useState } from 'react';
import '../styles/share-modal.css';
import { 
  Button, 
  Typography, 
  Space, 
  Tag, 
  Card, 
  Dropdown, 
  Tooltip, 
  Badge, 
  Modal, 
  Form, 
  Input, 
  message, 
  List,
  Popconfirm,
  Image,
  Upload,
  Empty
} from 'antd';
import { 
  ArrowLeftOutlined, 
  EditOutlined, 
  DeleteOutlined, 
  PlusOutlined, 
  CopyOutlined, 
  CheckOutlined, 
  FolderOutlined, 
  ClockCircleOutlined, 
  HistoryOutlined, 
  BranchesOutlined,
  SwapOutlined,
  UndoOutlined,
  TagOutlined,
  MoreOutlined,
  ExclamationCircleOutlined,
  ExportOutlined,
  FileOutlined,
  PictureOutlined,
  ShareAltOutlined,
  ContactsOutlined,
  LinkOutlined,
  InfoCircleOutlined,
  UserOutlined,
  MailOutlined,
  CheckCircleFilled
} from '@ant-design/icons';
import { exportPromptAsJson } from '../utils/exportService';
import DB from '../services/dbService'; // Import DB module

const { Title, Paragraph } = Typography;
const { TextArea } = Input;

// 格式化日期的全局辅助函数
const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// 将文本中的URL转换为可点击的链接
const renderTextWithLinks = (text) => {
  if (!text) return '';
  
  // URL匹配正则表达式
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  
  // 将文本分割成URL和非URL部分
  const parts = text.split(urlRegex);
  
  // 匹配所有URL
  const urls = text.match(urlRegex) || [];
  
  // 构建结果数组
  const result = [];
  parts.forEach((part, index) => {
    if (urls.includes(part)) {
      // 如果是URL，创建链接
      result.push(
        <a 
          key={index} 
          href={part} 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-blue-500 hover:text-blue-700 hover:underline"
        >
          {part}
        </a>
      );
    } else if (part) {
      // 如果是普通文本
      result.push(<span key={index}>{part}</span>);
    }
  });
  
  return result;
};

// 提示词详情组件，展示提示词内容和版本历史
function PromptDetail({ 
  prompt, 
  onBack, 
  onEdit, 
  onDelete, 
  onAddVersion, 
  onSwitchVersion,
  folders = [],
  onMoveToFolder,
  onCompareVersions,
  onViewTimeline,
  onCreateBranch,
  onRollbackVersion,
  onDeleteVersion,
  tags = [],
  onUpdatePrompt = () => {}
}) {
  const [showVersionHistory, setShowVersionHistory] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const [showBranchModal, setShowBranchModal] = useState(false);
  const [branchVersionIndex, setBranchVersionIndex] = useState(null);
  const [branchVersionNumber, setBranchVersionNumber] = useState('');
  const [branchDescription, setBranchDescription] = useState('');
  
  // 分享相关状态
  const [, setIsSharing] = useState(false);
  const [shareLink, setShareLink] = useState('');
  const [showShareModal, setShowShareModal] = useState(false);
  const [authorName, setAuthorName] = useState(prompt?.authorName || '');
  const [authorContact, setAuthorContact] = useState(prompt?.authorContact || '');
  const [showShareHistoryModal, setShowShareHistoryModal] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  
  // 添加新版本相关状态
  const [showAddVersionModal, setShowAddVersionModal] = useState(false);
  const [newVersionContent, setNewVersionContent] = useState('');
  const [newVersionNumber, setNewVersionNumber] = useState('');
  const [newVersionDescription, setNewVersionDescription] = useState('');
  const [newVersionImages, setNewVersionImages] = useState([]);

  // 安全检查
  if (!prompt) return null;

  // 获取当前版本
  const currentVersion = prompt.versions[prompt.currentVersionIndex];



  // 复制提示词内容到剪贴板
  const handleCopyContent = () => {
    try {
      navigator.clipboard.writeText(currentVersion.content)
        .then(() => {
          setCopySuccess(true);
          message.success('复制成功');
          
          // 记录复制次数
          if (prompt && prompt.id) {
            console.log('开始记录复制次数，提示词ID:', prompt.id);
            DB.incrementCopyCount(prompt.id)
              .then(() => {
                console.log('复制次数记录成功');
              })
              .catch(err => {
                console.error('复制次数记录失败:', err);
              });
          }
          
          setTimeout(() => setCopySuccess(false), 2000); // 2秒后隐藏成功提示
        })
        .catch(err => {
          console.error('复制失败:', err);
          message.error('复制失败，请手动选择文本复制');
        });
    } catch (error) {
      console.error('复制操作异常:', error);
      message.error('复制失败，请手动选择文本复制');
    }
  };

  // 处理分享开关切换 - 未使用的函数
  /*const handleShareToggle = async (checked) => {
    try {
      // 设置加载状态
      const updatingPrompt = {...prompt, isUpdating: true};
      // 如果有onUpdatePrompt函数，则调用它
      if (typeof onUpdatePrompt === 'function') {
        onUpdatePrompt(updatingPrompt);
      }
      
      // 调用数据库服务切换分享状态
      const result = await DB.togglePromptSharing(prompt.id, checked);
      
      if (result.success) {
        // 更新提示词对象
        const updatedPrompt = {
          ...prompt,
          isShared: checked,
          shareId: result.shareId,
          isUpdating: false
        };
        
        // 如果有onUpdatePrompt函数，则调用它更新父组件
        if (typeof onUpdatePrompt === 'function') {
          onUpdatePrompt(updatedPrompt);
        }
        
        // 直接更新当前组件的prompt对象（仍需要父组件处理真正的数据更新）
        // 这只是临时UI显示的更新
        prompt.isShared = checked;
        prompt.shareId = result.shareId;
        prompt.isUpdating = false;
        
        // 如果是启用分享，则生成分享链接
        if (checked && result.shareId) {
          const host = window.location.origin;
          const shareUrl = `${host}/share/${result.shareId}`;
          
          // 显示分享链接模态窗口
          Modal.confirm({
            title: '分享链接已生成',
            icon: <ShareAltOutlined style={{ color: 'var(--apple-accent)' }} />,
            content: (
              <div className="my-4">
                <p className="mb-4">任何人都可以通过下面的链接查看这个提示词，但他们只能查看和复制，不能编辑。</p>
                
                <div className="flex items-center gap-2 mb-4">
                  <Input 
                    value={shareUrl} 
                    readOnly 
                    addonBefore="链接"
                    className="flex-1" 
                  />
                </div>
              </div>
            ),
            okText: '复制链接',
            cancelText: '关闭',
            onOk: () => {
              navigator.clipboard.writeText(shareUrl)
                .then(() => {
                  message.success('分享链接已复制到剪贴板');
                })
                .catch(() => {
                  message.error('复制失败，请手动选择并复制链接');
                });
            }
          });
        } else {
          message.success('已取消分享');
        }
      } else {
        // 更新失败，恢复原状态
        if (typeof onUpdatePrompt === 'function') {
          onUpdatePrompt({...prompt, isUpdating: false});
        }
        message.error('操作失败，请稍后重试');
      }
    } catch (error) {
      console.error('切换分享状态失败:', error);
      // 恢复原状态
      if (typeof onUpdatePrompt === 'function') {
        onUpdatePrompt({...prompt, isUpdating: false});
      }
      message.error('操作失败，请稍后重试');
    }
  };*/
  
  /* 查看分享历史函数已经在下面定义 */
  
  // 分享当前提示词
  const handleSharePrompt = () => {
    // 如果已经分享过，直接展示链接和作者信息
    if (prompt.isShared && prompt.shareId) {
      const host = window.location.origin;
      const shareUrl = `${host}/share/${prompt.shareId}`;
      
      // 预填充现有的作者信息
      setAuthorName(prompt.authorName || '');
      setAuthorContact(prompt.authorContact || '');
      setVerificationCode(prompt.verificationCode || '');
      setShareLink(shareUrl);
      setShowShareModal(true);
    } else {
      // 请求开启分享，显示作者信息表单
      setAuthorName(prompt.authorName || '');
      setAuthorContact(prompt.authorContact || '');
      setShareLink('');
      setShowShareModal(true);
    }
  };
  
  // 查看分享历史
  const handleViewShareHistory = () => {
    if (prompt.shareHistory && prompt.shareHistory.length > 0) {
      setShowShareHistoryModal(true);
    } else {
      message.info('暂无分享历史记录');
    }
  };
  
  // 处理作者信息保存和分享开启
  const handleSaveAuthorInfo = async () => {
    try {
      // 设置加载状态
      setIsSharing(true);
      
      // 记录分享历史
      const now = new Date();
      const shareHistory = prompt.shareHistory || [];
      const newShareEvent = {
        date: now.toISOString(),
        authorName: authorName,
        authorContact: authorContact,
        verificationCode: '' // 这将由后端生成并返回
      };
      
      // 调用数据库服务切换分享状态，并传递作者信息
      const result = await DB.togglePromptSharing(prompt.id, true, authorName, authorContact);
      
      if (result.success) {
        // 更新提示词对象
        const updatedPrompt = {
          ...prompt,
          isShared: true,
          shareId: result.shareId,
          verificationCode: result.verificationCode,
          authorName,
          authorContact,
          shareHistory: [...shareHistory, newShareEvent] // 添加新的分享记录
        };
        
        // 更新验证码状态
        setVerificationCode(result.verificationCode);
        
        // 更新父组件中的提示词
        if (typeof onUpdatePrompt === 'function') {
          onUpdatePrompt(updatedPrompt);
        }
        
        // 生成分享链接
        const host = window.location.origin;
        const shareUrl = `${host}/share/${result.shareId}`;
        setShareLink(shareUrl);
        message.success('分享信息已保存，链接已生成');
      } else {
        message.error('生成分享链接失败');
      }
    } catch (error) {
      console.error('保存作者信息失败:', error);
      message.error('保存作者信息失败，请稍后重试');
    } finally {
      setIsSharing(false);
    }
  };
  
  // 处理取消分享
  const handleCancelSharing = async () => {
    try {
      setIsSharing(true);
      
      // 调用数据库服务关闭分享
      const result = await DB.togglePromptSharing(prompt.id, false);
      
      if (result.success) {
        // 保留分享历史记录，但更新分享状态
        const updatedPrompt = {
          ...prompt,
          isShared: false,
          shareId: null,
          authorName: null,
          authorContact: null
          // 不删除shareHistory，保留历史记录
        };
        
        // 更新父组件中的提示词
        if (typeof onUpdatePrompt === 'function') {
          onUpdatePrompt(updatedPrompt);
        }
        
        // 清除分享链接
        setShareLink('');
        setShowShareModal(false);
        message.success('已取消分享');
      } else {
        message.error('取消分享失败');
      }
    } catch (error) {
      console.error('取消分享失败:', error);
      message.error('取消分享失败，请稍后重试');
    } finally {
      setIsSharing(false);
    }
  };
  


  // 获取文件夹名称
  const getFolderName = (folderId) => {
    if (!folderId) return "未分类";
    const folder = folders.find(f => f.id === folderId);
    return folder ? folder.name : "未分类";
  };

  // 获取标签名称
  const getTagName = (tagId) => {
    if (!tagId) return null;
    const tag = tags.find(t => t.id === tagId);
    return tag ? tag.name : tagId; // 如果找不到标签，则显示ID作为后备
  };

  // 移动到文件夹
  const handleMoveToFolder = (folderId) => {
    onMoveToFolder(prompt.id, folderId);
    message.success('已移动到文件夹');
  };

  // 处理创建分支
  const handleCreateBranch = (versionIndex) => {
    setBranchVersionIndex(versionIndex);
    setBranchVersionNumber(`${prompt.versions.length + 1}.0`);
    setBranchDescription(`从版本 ${versionIndex + 1} 创建的分支`);
    setShowBranchModal(true);
  };

  const submitBranch = () => {
    if (!branchVersionNumber.trim()) {
      message.error('请输入版本号');
      return;
    }

    onCreateBranch(branchVersionIndex, {
      versionNumber: branchVersionNumber.trim(),
      description: branchDescription.trim() || `从版本 ${branchVersionIndex + 1} 创建的分支`
    });

    setShowBranchModal(false);
    setBranchVersionIndex(null);
    setBranchVersionNumber('');
    setBranchDescription('');
    message.success('分支创建成功');
  };
  
  // 处理添加新版本
  const handleAddVersionClick = () => {
    setNewVersionContent(currentVersion.content);
    setNewVersionNumber(`${prompt.versions.length + 1}.0`);
    setNewVersionDescription(`版本 ${prompt.versions.length + 1}`);
    setNewVersionImages([]);
    setShowAddVersionModal(true);
  };
  
  // 提交新版本
  const submitNewVersion = () => {
    if (!newVersionContent.trim()) {
      message.error('请输入版本内容');
      return;
    }
    
    // 处理上传图片数据，确保所有必要字段存在
    const processedImages = newVersionImages.map(img => {
      // 确保从响应或直接属性中获取URL和key
      const url = img.url || (img.response && img.response.url);
      const key = img.key || (img.response && img.response.key);
      
      // 打印日志以便于调试
      console.log('Processing image:', { original: img, processed: { url, key, uid: img.uid, name: img.name } });
      
      return {
        url,
        key,
        uid: img.uid,
        name: img.name
      };
    }).filter(img => img.url && img.key); // 只保留有效的图片
    
    console.log('Submitting processed images:', processedImages);
    
    onAddVersion({
      content: newVersionContent.trim(),
      versionNumber: newVersionNumber.trim() || `${prompt.versions.length + 1}.0`,
      description: newVersionDescription.trim() || `版本 ${prompt.versions.length + 1}`,
      resultImages: processedImages
    });
    
    setShowAddVersionModal(false);
    setNewVersionContent('');
    setNewVersionNumber('');
    setNewVersionDescription('');
    setNewVersionImages([]);
    message.success('新版本添加成功');
  };

  // 处理删除版本
  const handleDeleteVersion = (index) => {
    // 如果只有一个版本，不允许删除
    if (prompt.versions.length <= 1) {
      message.error('无法删除唯一的版本');
      return;
    }
    
    Modal.confirm({
      title: '确定要删除这个版本吗？',
      icon: <ExclamationCircleOutlined style={{ color: 'var(--apple-red)' }} />,
      content: (
        <div>
          <p>您确定要删除版本 {index + 1} 吗？此操作无法撤销。</p>
          {index === prompt.currentVersionIndex && (
            <p style={{ color: 'var(--apple-red)', fontWeight: 'bold', marginTop: '8px' }}>
              注意：这是当前使用的版本，删除后将切换到最新版本。
            </p>
          )}
        </div>
      ),
      okText: '删除',
      okButtonProps: { danger: true },
      cancelText: '取消',
      onOk: () => {
        onDeleteVersion(index);
        message.success('版本已删除');
      },
    });
  };

  // 处理导出提示词
  const handleExportPrompt = (format) => {
    if (format === 'json') {
      const success = exportPromptAsJson(prompt);
      if (success) {
        message.success('提示词已导出为JSON文件');
      } else {
        message.error('导出失败，请重试');
      }
    }
  };

  // 导出菜单
  const exportMenu = {
    items: [
      {
        key: 'json',
        icon: <FileOutlined />,
        label: '导出为JSON',
        onClick: () => handleExportPrompt('json')
      }
    ]
  };

  // 文件夹下拉菜单
  const folderMenu = {
    items: [
      {
        key: 'uncategorized',
        icon: <FolderOutlined />,
        label: '未分类',
        onClick: () => handleMoveToFolder(null)
      },
      ...folders.map(folder => ({
        key: folder.id,
        icon: <FolderOutlined />,
        label: folder.name,
        onClick: () => handleMoveToFolder(folder.id)
      }))
    ]
  };

  // 版本操作下拉菜单
  const getVersionMenu = (index) => ({
    items: [
      {
        key: 'branch',
        icon: <BranchesOutlined />,
        label: '从此版本创建分支',
        onClick: (e) => {
          e.domEvent.stopPropagation();
          handleCreateBranch(index);
        }
      },
      {
        key: 'rollback',
        icon: <UndoOutlined />,
        label: '回滚到此版本',
        onClick: (e) => {
          e.domEvent.stopPropagation();
          onRollbackVersion(index);
        }
      },
      {
        key: 'delete',
        icon: <DeleteOutlined />,
        label: '删除此版本',
        danger: true,
        onClick: (e) => {
          e.domEvent.stopPropagation();
          handleDeleteVersion(index);
        },
        disabled: prompt.versions.length <= 1
      }
    ]
  });

  return (
    <Card 
      variant="outlined" 
      className="card-modern shadow-medium prompt-detail-card rounded-2xl border-subtle overflow-hidden"
      styles={{ body: { padding: '24px' } }}
    >
      {/* 顶部操作栏 */}
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center">
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={onBack}
            className="btn-modern-secondary mr-4"
          />
          <Title level={4} style={{ margin: 0, fontWeight: 600 }} className="text-[var(--apple-text-primary)]">{prompt.title}</Title>
        </div>
        
        <Space size={12}>
          <Tooltip title="添加新版本">
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleAddVersionClick}
              className="btn-modern-primary"
            >
              新版本
            </Button>
          </Tooltip>
          
          <Dropdown menu={exportMenu} placement="bottomRight">
            <Button
              icon={<ExportOutlined />}
              className="btn-modern-secondary"
            >
              导出
            </Button>
          </Dropdown>
          
          {/* 分享历史按钮 */}
          {prompt.shareHistory && prompt.shareHistory.length > 0 && (
            <Tooltip title="查看分享历史">
              <Button
                icon={<HistoryOutlined />}
                onClick={handleViewShareHistory}
                className="btn-modern-secondary"
              >
                分享历史
              </Button>
            </Tooltip>
          )}

          <Tooltip title={prompt.isShared ? '管理分享链接' : '分享提示词'}>
            <Button
              icon={<ShareAltOutlined />}
              onClick={handleSharePrompt}
              className={prompt.isShared ? "bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white border-green-500 hover:border-green-600 shadow-sm hover:shadow transition-all" : "btn-modern-secondary"}
            >
              {prompt.isShared ? (
                <span className="flex items-center">
                  <span className="relative flex h-2 w-2 mr-1.5">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-200 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-green-400"></span>
                  </span>
                  已分享
                </span>
              ) : '分享'}
            </Button>
          </Tooltip>
          
          <Tooltip title="编辑提示词">
            <Button
              icon={<EditOutlined />}
              onClick={onEdit}
              className="btn-modern-secondary"
            >
              编辑
            </Button>
          </Tooltip>
          
          <Popconfirm
            title="确定要删除这个提示词吗？"
            onConfirm={async () => {
              try {
                const success = await onDelete(prompt.id);
                if (success) {
                  message.success('提示词删除成功');
                }
              } catch (error) {
                console.error('删除提示词失败:', error);
              }
            }}
            okText="是"
            cancelText="否"
            placement="bottomRight"
            icon={<ExclamationCircleOutlined style={{ color: 'var(--apple-danger)' }} />}
          >
            <Button 
              danger
              icon={<DeleteOutlined />}
              className="hover:bg-[var(--apple-danger-hover-bg)] hover:text-[var(--apple-danger)] hover:border-[var(--apple-danger)]"
            >
              删除
            </Button>
          </Popconfirm>
        </Space>
      </div>
      
      {/* 提示词元数据区域 */}
      <div className="metadata-section bg-[var(--apple-bg-secondary)] rounded-xl p-4 mb-6 flex flex-wrap justify-between items-center">
        <Space size={12} wrap>
          {/* 文件夹信息 */}
          <Dropdown menu={folderMenu} trigger={['click']} placement="bottomLeft">
            <Tooltip title="设置文件夹">
              <div className="folder-tag cursor-pointer">
                <FolderOutlined className="mr-1" />
                <span>{getFolderName(prompt.folderId)}</span>
              </div>
            </Tooltip>
          </Dropdown>
          
          {/* 标签信息 */}
          {prompt.tags && prompt.tags.length > 0 && (
            <div className="flex flex-wrap gap-1">
              {prompt.tags.map(tagId => (
                <Tag 
                  key={tagId} 
                  className="tag-modern"
                >
                  <TagOutlined className="mr-1" />
                  <span>{getTagName(tagId)}</span>
                </Tag>
              ))}
            </div>
          )}
        </Space>
        
        {/* 时间信息 */}
        <Space size={16}>
          <Tooltip title="创建时间">
            <div className="flex items-center text-xs text-[var(--apple-text-tertiary)]">
              <ClockCircleOutlined className="mr-1" />
              <span>创建于 {formatDate(prompt.createdAt)}</span>
            </div>
          </Tooltip>
          
          <Tooltip title="最后更新时间">
            <div className="flex items-center text-xs text-[var(--apple-text-tertiary)]">
              <ClockCircleOutlined className="mr-1" />
              <span>更新于 {formatDate(prompt.updatedAt)}</span>
            </div>
          </Tooltip>
        </Space>
      </div>
      
      {/* 简介显示 */}
      {prompt.introduction && (
        <div className="mb-6">
          <Title level={5} className="text-[var(--apple-text-primary)] mb-2 font-medium">简介</Title>
          <Paragraph className="text-[var(--apple-text-secondary)] bg-[var(--apple-bg-secondary)] p-4 rounded-xl">
            {renderTextWithLinks(prompt.introduction)}
          </Paragraph>
        </div>
      )}
      
      {/* 版本导航 */}
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center" data-component-name="PromptDetail">
          <Title level={5} className="text-[var(--apple-text-primary)] m-0 font-medium mr-2">当前版本</Title>
          <Dropdown 
            menu={{ 
              items: prompt.versions.map((version, idx) => ({
                key: idx,
                label: `v${version.versionNumber || (idx + 1)}`,
                className: prompt.currentVersionIndex === idx ? 'bg-[var(--apple-selected-bg)] text-[var(--apple-accent)]' : ''
              })),
              onClick: ({ key }) => onSwitchVersion(parseInt(key))
            }} 
            placement="bottomLeft"
            trigger={['click']}
          >
            <Badge 
              count={`v${currentVersion.versionNumber || (prompt.currentVersionIndex + 1)}`} 
              style={{ backgroundColor: 'var(--apple-accent)' }}
              className="badge-elegant cursor-pointer hover:opacity-80 transition-opacity"
            />
          </Dropdown>
        </div>
        
        {prompt.versions.length > 1 && (
          <Space>
            <Button 
              type="default" 
              icon={<BranchesOutlined />} 
              onClick={() => onViewTimeline(prompt.id)}
              className="btn-modern-secondary"
            >
              查看时间线
            </Button>
            <Button 
              type="default" 
              icon={<SwapOutlined />} 
              onClick={() => onCompareVersions(prompt.id)}
              className="btn-modern-secondary"
            >
              比较版本
            </Button>
            <Button 
              type={showVersionHistory ? "primary" : "default"} 
              icon={<HistoryOutlined />} 
              onClick={() => setShowVersionHistory(!showVersionHistory)}
              className={showVersionHistory ? "btn-modern-primary" : "btn-modern-secondary"}
            >
              {showVersionHistory ? "隐藏历史" : "查看历史"}
            </Button>
          </Space>
        )}
      </div>
      
      {/* 版本历史 */}
      {showVersionHistory && (
        <div className="version-history-section mb-6">
          <div className="divider-elegant mb-4"></div>
          <Title level={5} className="text-[var(--apple-text-primary)] mb-4 font-medium">版本历史</Title>
          <List
            className="version-list scrollbar-elegant"
            style={{ maxHeight: '300px', overflowY: 'auto' }}
            itemLayout="horizontal"
            dataSource={prompt.versions}
            renderItem={(version, index) => (
              <List.Item
                className={`
                  p-3 mb-2 rounded-xl transition-all cursor-pointer hover-lift
                  ${prompt.currentVersionIndex === index 
                    ? 'bg-[var(--apple-selected-bg)] border border-[var(--apple-accent-light)]' 
                    : 'bg-[var(--apple-bg-secondary)] border border-transparent hover:border-[var(--apple-border)]'}
                `}
                onClick={() => onSwitchVersion(index)}
                actions={[
                  <Dropdown menu={getVersionMenu(index)} trigger={['click']} placement="bottomRight">
                    <Button
                      icon={<MoreOutlined />}
                      type="text"
                      size="small"
                      className="text-[var(--apple-text-tertiary)]"
                      onClick={(e) => e.stopPropagation()}
                    />
                  </Dropdown>
                ]}
              >
                <List.Item.Meta
                  title={
                    <div className="flex items-center">
                      <Badge 
                        count={`v${version.versionNumber || (index + 1)}`} 
                        style={{ 
                          backgroundColor: prompt.currentVersionIndex === index 
                            ? 'var(--apple-accent)' 
                            : 'var(--apple-gray-400)' 
                        }}
                        className="mr-2"
                      />
                      <span className={prompt.currentVersionIndex === index ? 'text-[var(--apple-accent)] font-medium' : 'text-[var(--apple-text-primary)]'}>
                        {version.description || `版本 ${version.versionNumber || (index + 1)}`}
                      </span>
                    </div>
                  }
                  description={
                    <div className="flex items-center text-xs text-[var(--apple-text-tertiary)]">
                      <ClockCircleOutlined className="mr-1" />
                      <span>{formatDate(version.createdAt)}</span>
                    </div>
                  }
                />
              </List.Item>
            )}
          />
          <div className="divider-elegant mt-4 mb-4"></div>
        </div>
      )}
      
      {/* 版本描述 */}
      {currentVersion.description && (
        <Paragraph className="text-[var(--apple-text-secondary)] mb-4">
          {renderTextWithLinks(currentVersion.description)}
        </Paragraph>
      )}
      
      {/* 提示词内容 */}
      <div className="content-section mb-6">
        <div className="flex justify-between items-center mb-2">
          <Title level={5} className="text-[var(--apple-text-primary)] m-0 font-medium">提示词内容</Title>
          <Button 
            icon={copySuccess ? <CheckOutlined /> : <CopyOutlined />} 
            onClick={handleCopyContent}
            type={copySuccess ? "default" : "text"}
            className={copySuccess ? "text-[var(--apple-success)]" : "text-[var(--apple-text-secondary)]"}
          >
            {copySuccess ? "已复制" : "复制"}
          </Button>
        </div>
        <div className="content-display p-5 bg-[var(--apple-bg-secondary)] rounded-xl border-subtle shadow-soft scrollbar-elegant" style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <Paragraph 
            className="text-[var(--apple-text-primary)] whitespace-pre-wrap font-mono text-sm leading-relaxed m-0"
            style={{ wordBreak: 'break-word' }}
          >
            {renderTextWithLinks(currentVersion.content)}
          </Paragraph>
        </div>
      </div>
      
      {/* 结果图片展示区域 - 合并所有版本 */}
      {(() => {
        console.log('当前版本数据:', currentVersion);
        
        // 处理并显示所有版本的图片
        // 创建一个对象来跟踪已经处理过的图片键，防止重复
        const processedKeys = new Set();
        const allImages = [];
        
        // 首先处理当前版本的图片，确保当前版本图片优先显示
        if (currentVersion.resultImages && Array.isArray(currentVersion.resultImages)) {
          currentVersion.resultImages.forEach(img => {
            if (img && img.url && img.key) {
              processedKeys.add(img.key); // 标记此图片已经处理
              allImages.push({
                ...img,
                versionNumber: img.versionNumber || currentVersion.versionNumber,
                versionDescription: currentVersion.description,
                isCurrent: true
              });
            } else {
              console.warn('当前版本中跳过无效图片:', img);
            }
          });
        }
        
        console.log('当前版本图片处理后:', allImages);

        // 如果显示历史版本，则遍历其他所有版本的图片
        // 从新到旧顺序显示，这样最新的版本会优先显示
        if (showVersionHistory) {
          // 按版本索引降序排列，从新到旧
          const sortedVersions = [...prompt.versions].reverse();
          
          for (const version of sortedVersions) {
            if (version.id === currentVersion.id) continue; // 跳过当前版本，因为已经处理过
            
            if (version.resultImages && Array.isArray(version.resultImages)) {
              version.resultImages.forEach(img => {
                if (img && img.url && img.key && !processedKeys.has(img.key)) {
                  processedKeys.add(img.key); // 标记此图片已经处理
                  allImages.push({
                    ...img,
                    versionNumber: img.versionNumber || version.versionNumber,
                    versionDescription: version.description,
                    isCurrent: false
                  });
                }
              });
            }
          }
        }
        
        console.log('处理后的所有图片:', allImages);
        
        if (allImages.length === 0) return null;
        
        return (
           <div className="result-images-section mb-8">
            <div className="flex justify-between items-center mb-4">
              <Title level={4} className="text-[var(--apple-text-primary)] m-0 font-medium flex items-center">
                <div className="w-8 h-8 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center mr-3">
                  <PictureOutlined className="text-[var(--apple-accent)] text-lg" />
                </div>
                运行结果展示
              </Title>
            </div>
            
            <div className="image-gallery p-6 bg-gradient-to-br from-[var(--apple-bg-secondary)] to-[var(--apple-bg-secondary)] backdrop-blur-sm rounded-2xl border-subtle shadow-xl">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {allImages.map((image, index) => (
                  <div 
                    key={`img-${index}-${image.uid || image.key}`} 
                    className={`image-item relative group transition-all duration-300 rounded-xl overflow-hidden mb-4 ${image.isCurrent ? 'ring-2 ring-[var(--apple-accent)]' : ''}`}
                  >
                    <Image
                      src={image.url}
                      alt={`结果图片 ${index + 1}`}
                      width={250}
                      height={200}
                      style={{ objectFit: 'contain' }}
                      className="transition-all duration-500 group-hover:scale-105 rounded-lg shadow-sm"
                      preview={{
                        mask: (
                          <div className="flex flex-col items-center justify-center space-y-1">
                            <PictureOutlined className="text-lg" />
                            <span className="text-sm font-medium">预览图片</span>
                          </div>
                        ),
                      }}
                      fallback="data:image/png;base64,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"
                    />
                    
                    <div className="absolute top-0 left-0 right-0 flex justify-between items-center p-3 bg-gradient-to-b from-black/60 to-transparent">
                      <Tag 
                        color={image.isCurrent ? 'blue' : 'default'}
                        className="rounded-full opacity-90 backdrop-blur-sm shadow-sm flex items-center py-1 px-3"
                      >
                        <span className="text-xs font-medium">版本 {image.versionNumber}</span>
                      </Tag>
                      
                      <Tooltip title="查看大图">
                        <Button 
                          type="text" 
                          shape="circle" 
                          icon={<PictureOutlined />} 
                          className="bg-white/30 hover:bg-white/50 backdrop-blur-sm text-white shadow-sm" 
                          size="small"
                        />
                      </Tooltip>
                    </div>
                    
                    {image.versionDescription && (
                      <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/70 to-transparent">
                        <div className="px-3 py-2 bg-black/30 backdrop-blur-sm rounded-lg text-white text-xs font-medium shadow-inner">
                          {image.versionDescription}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        );
      })()} 
      
      {/* 创建分支模态框 */}
      {/* 分享历史模态框 */}
      <Modal
        title={<div className="flex items-center gap-2">
          <HistoryOutlined className="text-blue-500 text-lg" />
          <span className="font-medium text-lg">分享历史记录</span>
        </div>}
        open={showShareHistoryModal}
        onCancel={() => setShowShareHistoryModal(false)}
        width={550}
        className="share-history-modal"
        bodyStyle={{ padding: '20px' }}
        footer={[
          <Button 
            key="close" 
            onClick={() => setShowShareHistoryModal(false)}
            className="hover:bg-gray-50 dark:hover:bg-gray-800 border-gray-200 dark:border-gray-700 transition-colors"
          >
            关闭
          </Button>
        ]}
      >
        {prompt.shareHistory && prompt.shareHistory.length > 0 ? (
          <List
            dataSource={prompt.shareHistory}
            renderItem={(record, index) => (
              <List.Item className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 p-4 mb-3 shadow-sm hover:shadow transition-shadow">
                <List.Item.Meta
                  title={
                    <div className="flex items-center mb-2">
                      <div className="bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-300 text-xs font-medium px-2.5 py-1 rounded-full mr-2 flex items-center">
                        #{index + 1}
                      </div>
                      <span className="text-gray-800 dark:text-gray-200 font-medium">{record.authorName || '未署名'}</span>
                    </div>
                  }
                  description={
                    <div className="pl-1">
                      <div className="flex items-center text-xs text-gray-500 dark:text-gray-400 mb-2 bg-gray-50 dark:bg-gray-700/50 px-3 py-1.5 rounded-lg">
                        <ClockCircleOutlined className="mr-1.5 text-blue-400" />
                        <span>分享于: {formatDate(record.date)}</span>
                      </div>
                      {record.authorContact && (
                        <div className="flex items-center text-xs text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-700/50 px-3 py-1.5 rounded-lg ml-2">
                          <ContactsOutlined className="mr-1.5 text-green-400" />
                          <span>{record.authorContact}</span>
                        </div>
                      )}
                    </div>
                  }
                />
              </List.Item>
            )}
          />
        ) : (
          <Empty description="暂无分享历史记录" />
        )}
      </Modal>
      
      {/* 分享模态框 */}
      <Modal
        title={<div className="flex items-center gap-2">
          <ShareAltOutlined className="text-blue-500 text-lg" />
          <span className="font-medium text-lg bg-gradient-to-r from-blue-500 to-purple-500 text-transparent bg-clip-text">分享提示词</span>
        </div>}
        open={showShareModal}
        onCancel={() => setShowShareModal(false)}
        width={550}
        className="share-modal"
        bodyStyle={{ padding: '24px' }}
        footer={[
          prompt.isShared ? (
            <Button 
              key="cancel" 
              className="cancel-share-button"
              danger
              icon={<DeleteOutlined />}
              onClick={handleCancelSharing}
            >
              取消分享
            </Button>
          ) : null,
          <Button 
            key="close" 
            className="hover:bg-gray-50 dark:hover:bg-gray-800 border-gray-200 dark:border-gray-700 transition-colors"
            onClick={() => setShowShareModal(false)}
          >
            关闭
          </Button>,
          !prompt.isShared ? (
            <Button 
              key="share" 
              type="primary"
              className="save-button"
              icon={<ShareAltOutlined />}
              onClick={handleSaveAuthorInfo}
            >
              生成分享链接
            </Button>
          ) : null
        ].filter(Boolean)}
      >
        {prompt.isShared ? (
          <div>
            <div className="mb-5">
              <div className="flex items-center mb-3">
                <div className="section-tag bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-300">
                  <LinkOutlined className="mr-2" />
                  <span>分享链接</span>
                </div>
              </div>
              <div className="share-link-card p-4">
                <div className="mb-3 pb-3 border-b border-blue-100 dark:border-blue-800/30">
                  <div className="text-blue-700 dark:text-blue-300 font-medium mb-1 flex items-center">
                    <LinkOutlined className="mr-2" /> 分享链接
                  </div>
                  <div className="text-xs text-blue-500/70 dark:text-blue-400/70">
                    使用下方链接与他人分享该提示词
                  </div>
                </div>
                {verificationCode && (
                  <div className="mb-3 pb-3 border-b border-blue-100 dark:border-blue-800/30">
                    <div className="text-yellow-700 dark:text-yellow-300 font-medium mb-1 flex items-center">
                      <InfoCircleOutlined className="mr-2" /> 验证码
                    </div>
                    <div className="text-xs text-yellow-500/70 dark:text-yellow-400/70 mb-2">
                      请记住此验证码，对方需要输入才能查看提示词
                    </div>
                    <div className="flex justify-center">
                      <div className="bg-yellow-50 dark:bg-yellow-900/30 px-4 py-2 rounded-lg font-mono text-xl text-yellow-700 dark:text-yellow-300 tracking-widest font-bold">
                        {verificationCode}
                      </div>
                    </div>
                  </div>
                )}
                <div className="flex gap-2">
                  <Input 
                    value={shareLink} 
                    readOnly 
                    className="share-link-input flex-1" 
                    prefix={<LinkOutlined className="text-blue-400" />}
                  />
                  <Button 
                    type="primary" 
                    icon={<CopyOutlined />}
                    className="copy-button"
                    onClick={() => {
                      navigator.clipboard.writeText(shareLink);
                      message.success({
                        content: '分享链接已复制到剪切板',
                        icon: <CheckCircleFilled style={{ color: '#10b981' }} />
                      });
                    }}
                  >
                    复制
                  </Button>
                </div>
              </div>
            </div>
            <div className="info-card text-sm mb-5 bg-yellow-50 dark:bg-yellow-900/10 p-4 rounded-xl border border-yellow-100 dark:border-yellow-800/30 flex items-start shadow-sm">
              <div className="info-icon-wrapper bg-yellow-100 dark:bg-yellow-800/50">
                <InfoCircleOutlined className="text-yellow-500 dark:text-yellow-400 text-lg" />
              </div>
              <div>
                <div className="text-yellow-700 dark:text-yellow-300 font-medium mb-1">注意事项</div>
                <div className="text-yellow-600/80 dark:text-yellow-400/80">分享链接可以与任何人分享，对方需要输入验证码才能查看提示词内容</div>
              </div>
            </div>

            <div className="info-card bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
              <div className="mb-4 pb-3 border-b border-gray-100 dark:border-gray-700">
                <div className="text-gray-800 dark:text-gray-200 font-medium text-base flex items-center gap-2">
                  <UserOutlined className="text-blue-500" /> 
                  <span className="bg-gradient-to-r from-blue-500 to-indigo-500 text-transparent bg-clip-text">作者信息</span>
                </div>
                <div className="text-xs text-gray-500/80 dark:text-gray-400/80 mt-1">
                  添加作者信息可以让他人知道如何联系你
                </div>
              </div>
              <Form layout="vertical" className="author-form">
                <Form.Item 
                  label={<span className="text-gray-700 dark:text-gray-300 font-medium">作者姓名</span>}
                  className="mb-4"
                >
                  <Input 
                    placeholder="请输入作者名称（可选）" 
                    value={authorName}
                    onChange={(e) => setAuthorName(e.target.value)}
                    prefix={<UserOutlined className="text-gray-400" />}
                    className="border-gray-200 dark:border-gray-600 hover:border-blue-400 dark:hover:border-blue-500 transition-colors"
                  />
                </Form.Item>
                <Form.Item 
                  label={<span className="text-gray-700 dark:text-gray-300 font-medium">联系方式</span>}
                  className="mb-4"
                >
                  <Input 
                    placeholder="请输入联系方式（可选）" 
                    value={authorContact}
                    onChange={(e) => setAuthorContact(e.target.value)}
                    prefix={<MailOutlined className="text-gray-400" />}
                    className="border-gray-200 dark:border-gray-600 hover:border-blue-400 dark:hover:border-blue-500 transition-colors"
                  />
                </Form.Item>
                <div className="flex justify-end mt-2">
                  <Button 
                    type="primary" 
                    onClick={handleSaveAuthorInfo}
                    className="save-button"
                  >
                    保存作者信息
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        ) : (
          <div>
            <div className="info-card mb-5 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-xl border border-blue-100 dark:border-blue-800 shadow-sm">
              <div className="flex">
                <div className="info-icon-wrapper bg-blue-100 dark:bg-blue-800">
                  <InfoCircleOutlined className="text-blue-500 dark:text-blue-300 text-lg" />
                </div>
                <div>
                  <h4 className="text-blue-700 dark:text-blue-300 font-medium text-base mb-1">关于分享</h4>
                  <p className="text-blue-600/80 dark:text-blue-400/80 text-sm">
                    将提示词分享给他人，对方无需登录即可查看内容。如果你之后取消分享，链接将失效。
                  </p>
                </div>
              </div>
            </div>
            <div className="mb-5">
              <div className="flex items-center mb-3">
                <div className="section-tag bg-green-50 dark:bg-green-900/20 text-green-600 dark:text-green-300">
                  <ContactsOutlined className="mr-2" />
                  <span>作者信息</span>
                </div>
              </div>
              <div className="p-4 bg-gray-50 dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-inner">
                <Form layout="vertical" className="space-y-3">
                  <Form.Item 
                    label={<div className="flex items-center text-gray-700 dark:text-gray-300 font-medium">
                      <UserOutlined className="mr-1" />
                      <span>作者姓名</span>
                    </div>}
                    className="mb-3"
                  >
                    <Input 
                      placeholder="请输入作者名称（可选）" 
                      value={authorName}
                      onChange={(e) => setAuthorName(e.target.value)}
                      className="hover:border-blue-400 focus:border-blue-500 focus:shadow-sm transition-all"
                      prefix={<UserOutlined className="text-gray-400" />}
                    />
                  </Form.Item>
                  <Form.Item 
                    label={<div className="flex items-center text-gray-700 dark:text-gray-300 font-medium">
                      <MailOutlined className="mr-1" />
                      <span>联系方式</span>
                    </div>}
                    className="mb-0"
                  >
                    <Input 
                      placeholder="请输入联系方式（可选）" 
                      value={authorContact}
                      onChange={(e) => setAuthorContact(e.target.value)}
                      className="hover:border-blue-400 focus:border-blue-500 focus:shadow-sm transition-all"
                      prefix={<MailOutlined className="text-gray-400" />}
                    />
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        )}
      </Modal>
      
      <Modal
        title={`从版本 ${branchVersionIndex !== null ? branchVersionIndex + 1 : ''} 创建分支`}
        open={showBranchModal}
        onCancel={() => {
          setShowBranchModal(false);
          setBranchVersionIndex(null);
          setBranchVersionNumber('');
          setBranchDescription('');
        }}
        footer={[
          <Button 
            key="cancel" 
            onClick={() => {
              setShowBranchModal(false);
              setBranchVersionIndex(null);
              setBranchVersionNumber('');
              setBranchDescription('');
            }}
          >
            取消
          </Button>,
          <Button 
            key="submit" 
            type="primary" 
            icon={<BranchesOutlined />}
            onClick={submitBranch}
          >
            创建分支
          </Button>
        ]}
      >
        <Form layout="vertical">
          <Form.Item label="版本号">
            <Input
              placeholder={`${prompt.versions.length + 1}.0`}
              value={branchVersionNumber}
              onChange={(e) => setBranchVersionNumber(e.target.value)}
            />
          </Form.Item>
          
          <Form.Item label="描述">
            <Input
              placeholder={branchVersionIndex !== null ? `从版本 ${branchVersionIndex + 1} 创建的分支` : ''}
              value={branchDescription}
              onChange={(e) => setBranchDescription(e.target.value)}
            />
          </Form.Item>
        </Form>
      </Modal>
      
      {/* 添加新版本模态框 */}
      <Modal
        title="添加新版本"
        open={showAddVersionModal}
        width={700}
        onCancel={() => {
          setShowAddVersionModal(false);
          setNewVersionContent('');
          setNewVersionNumber('');
          setNewVersionDescription('');
        }}
        footer={[
          <Button 
            key="cancel" 
            onClick={() => {
              setShowAddVersionModal(false);
              setNewVersionContent('');
              setNewVersionNumber('');
              setNewVersionDescription('');
            }}
          >
            取消
          </Button>,
          <Button 
            key="submit" 
            type="primary" 
            icon={<PlusOutlined />}
            onClick={submitNewVersion}
          >
            添加版本
          </Button>
        ]}
      >
        <Form layout="vertical">
          <Form.Item label="版本号">
            <Input
              placeholder={`${prompt.versions.length + 1}.0`}
              value={newVersionNumber}
              onChange={(e) => setNewVersionNumber(e.target.value)}
            />
          </Form.Item>
          
          <Form.Item label="描述">
            <Input
              placeholder={`版本 ${prompt.versions.length + 1}`}
              value={newVersionDescription}
              onChange={(e) => setNewVersionDescription(e.target.value)}
            />
          </Form.Item>
          
          <Form.Item label="内容">
            <TextArea
              rows={10}
              placeholder="输入提示词内容..."
              value={newVersionContent}
              onChange={(e) => setNewVersionContent(e.target.value)}
            />
          </Form.Item>
          
          <Form.Item label="结果图片">
            <div className="mb-2">
              <p className="text-sm text-[var(--apple-text-tertiary)] mb-2">
                <PictureOutlined className="mr-1" />
                上传提示词的结果图片，最多5张
              </p>
              <div className="image-uploader">
                <Upload
                  listType="picture-card"
                  fileList={newVersionImages}
                  onChange={({ fileList }) => {
                    // 处理数据以确保上传结果正确保存
                    const processedList = fileList.map(file => {
                      if (file.status === 'done' && file.response) {
                        // 已上传成功，保证URL和key可用
                        return {
                          ...file,
                          url: file.response.url,  // 将响应中的URL存入标准属性
                          key: file.response.key,  // 将响应中的key存入标准属性
                          uid: file.uid || file.response.key,
                          name: file.name || 'image.jpg'
                        };
                      }
                      return file;
                    });
                    console.log('处理后的图片列表:', processedList);
                    setNewVersionImages(processedList);
                  }}
                  beforeUpload={(file) => {
                    const isImage = file.type.startsWith('image/');
                    if (!isImage) {
                      message.error('只能上传图片文件!');
                    }
                    const isLt5M = file.size / 1024 / 1024 < 5;
                    if (!isLt5M) {
                      message.error('图片大小不能超过5MB!');
                    }
                    return isImage && isLt5M; // 如果验证通过允许自动上传
                  }}
                  customRequest={(options) => {
                    const { file, onSuccess, onError, onProgress } = options;
                    import('../services/imageService').then((ImageService) => {
                      ImageService.default.uploadImage(file, percent => {
                        onProgress({ percent });
                      }).then(result => {
                        console.log('上传成功响应:', result);
                        onSuccess(result, file);
                      }).catch(err => {
                        console.error('上传错误:', err);
                        onError(err);
                        message.error(`上传失败: ${err.message}`);
                      });
                    });
                  }}
                  maxCount={5}
                  multiple={true}
                >
                  {newVersionImages.length >= 5 ? null : (
                    <div>
                      <PictureOutlined />
                      <div className="mt-2">上传图片</div>
                    </div>
                  )}
                </Upload>
              </div>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
}

export default PromptDetail;
